export type IndustrySeoEntry = {
  slug: string;
  heroTitle: string;
  seo: {
    title: string;
    description: string;
    image: string;
  };
  faq?: { q: string; a: string }[];
};

export const industrySeoEntries: IndustrySeoEntry[] = [
  {
    slug: "frisoer-booking-system",
    heroTitle: "Booking system til frisør, bygget til hverdagen i salonen",
    seo: {
      title: "Booking system til frisør | Nalosoft",
      description:
        "Få et booking system til frisører med online tidsbestilling, behandlinger, påmindelser, betaling og en hjemmeside der skaffer flere lokale kunder.",
      image: "/cases/mkcosmetics/mkcosmetics-booking1.png",
    },
  },
  {
    slug: "klinik-booking-system",
    heroTitle: "Booking system til klinik med fokus på tryghed og overblik",
    seo: {
      title: "Booking system til klinik | Nalosoft",
      description:
        "Få et klinik booking system med tryg online tidsbestilling, ydelsesforklaring, påmindelser og struktur til konsultationer, behandlinger og opfølgning.",
      image: "/cases/mkcosmetics/mkcosmetics-booking2.png",
    },
  },
  {
    slug: "webshop-til-smykker",
    heroTitle: "Webshop til smykker med fokus på tillid, detaljer og køb",
    seo: {
      title: "Webshop til smykker | Nalosoft",
      description:
        "Få en smykke webshop med produktfortælling, varianter, billeder, checkout, MobilePay og en købsrejse der skaber tillid omkring design og levering.",
      image: "/cases/armring/armring-homepage.png",
    },
  },
  {
    slug: "hjemmeside-til-lokal-virksomhed",
    heroTitle: "Hjemmeside til lokal virksomhed med klar kontaktvej",
    seo: {
      title: "Hjemmeside til lokal virksomhed | Nalosoft",
      description:
        "Få en professionel hjemmeside til lokal virksomhed med tydeligt tilbud, lokal SEO, kontaktflow, cases og en struktur der skaber flere henvendelser.",
      image: "/services/websites-service.jpg",
    },
  },
  {
    slug: "mobilapp-til-salon",
    heroTitle:
      "Mobilapp til salon, når booking og loyalitet skal tættere på kunden",
    seo: {
      title: "Mobilapp til salon | Nalosoft",
      description:
        "Få en mobilapp til salon med booking, loyalitet, beskeder og kunderejser der passer til frisører, beauty og behandlingssaloner.",
      image: "/services/mobile-apps-2.jpg",
    },
  },
  {
    slug: "booking-system-til-neglesalon",
    heroTitle:
      "Booking system til neglesalon med tydelige behandlinger og mindre admin",
    seo: {
      title: "Booking system til neglesalon | Nalosoft",
      description:
        "Få et booking system til neglesalon med online tidsbestilling, behandlinger, tillæg, påmindelser og en hjemmeside der gør nye kunder trygge.",
      image: "/cases/mkcosmetics/mkcosmetics-booking1.png",
    },
    faq: [
      {
        q: "Kan kunder vælge tillæg som nail art eller reparation?",
        a:
          "Ja. Tillæg kan indgå i bookingflowet, så kunden vælger mere præcist og salonen bedre kan planlægge tiden.",
      },
      {
        q: "Kan systemet håndtere opfyldning og nyt sæt forskelligt?",
        a:
          "Ja. Behandlingerne kan have egne varigheder, priser, beskrivelser og regler.",
      },
      {
        q: "Kan kunder sende noter eller inspiration?",
        a:
          "Det kan scopes som en del af flowet, hvis salonen har brug for at kende designønsker før tiden.",
      },
      {
        q: "Kan siden hjælpe med lokal synlighed?",
        a:
          "Ja. Behandlinger, priser, billeder og lokal information kan struktureres, så Google og kunder bedre forstår salonen.",
      },
    ],
  },
  {
    slug: "hjemmeside-til-haandvaerker",
    heroTitle:
      "Hjemmeside til håndværker med lokale ydelser og tydelig kontaktvej",
    seo: {
      title: "Hjemmeside til håndværker | Nalosoft",
      description:
        "Få en professionel hjemmeside til håndværker med lokale servicesider, kontaktflow, cases, billeder og en struktur der skaber flere kvalificerede henvendelser.",
      image: "/services/websites-service.jpg",
    },
    faq: [
      {
        q: "Hvor mange sider skal en håndværker starte med?",
        a:
          "Ofte er en stærk forside, 3-5 servicesider, en kontaktvej og nogle cases nok til første version.",
      },
      {
        q: "Kan siden målrettes flere byer?",
        a:
          "Ja, men lokale sider skal have reel værdi og ikke bare være kopier.",
      },
      {
        q: "Kan kunder sende billeder af opgaven?",
        a:
          "Det kan indgå i startflowet, hvis du vil modtage bedre forespørgsler og vurdere opgaven hurtigere.",
      },
      {
        q: "Kan hjemmesiden senere udvides med tilbudssystem?",
        a:
          "Ja. Et godt websitefundament kan senere udbygges med tilbudsflow, kundeportal, booking eller andre specialfunktioner.",
      },
    ],
  },
];

export const industrySeoBySlug = industrySeoEntries.reduce<
  Record<string, IndustrySeoEntry>
>((acc, entry) => {
  acc[entry.slug] = entry;
  return acc;
}, {});
